import { HttpLink, InMemoryCache, ApolloClient } from 'apollo-boost'
import { WebSocketLink } from 'apollo-link-ws'
import { ApolloLink, split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'
import { withClientState } from 'apollo-link-state'

const TOKEN_KEY = 'AUTH_TOKEN';

const cache = new InMemoryCache();

const defaultState = {
  loggedUser: {
    __typename: 'LoggedUser',
    token: null,
    expires: null,
    user: null
  }
};

const stateLink = withClientState({
  cache,
  defaults: defaultState
});

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_API_QUERY_ENDPOINT
});

const middlewareLink = new ApolloLink((operation, forward) => {
  // get the authentication token from local storage if it exists
  const tokenValue = localStorage.getItem(TOKEN_KEY)
  // return the headers to the context so httpLink can read them
  operation.setContext({
    headers: {
      Authorization: tokenValue ? `Bearer ${tokenValue}` : ''
    }
  })
  return forward(operation)
})

// authenticated httplink
const httpLinkAuth = middlewareLink.concat(httpLink)

const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_API_SUBSCRIPTION_ENDPOINT,
  options: {
    reconnect: true,
    connectionParams: {
      Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`
    }
  }
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query)
    return kind === 'OperationDefinition' && operation === 'subscription'
  },
  wsLink,
  httpLinkAuth
);

// apollo client setup
const client = new ApolloClient({
  link: ApolloLink.from([
    stateLink,
    link
  ]),
  cache,
  connectToDevTools: true,
});

export default client;



// WEBPACK FOOTER //
// ./src/apollo.js